import React, { Component } from 'react';
import { QueryResult } from 'react-apollo';
import { Route, RouteComponentProps, withRouter } from 'react-router';

import { Content, GetContentComponent, GetContentDocument } from 'api';
import { PostAction } from 'types/app';
import { ContentProvider, DimensionsProvider, QueryParamsProvider } from 'providers';
import { Dimensions, Layouts, NotFound, QueryManager } from 'components';
import { Post, IPostRenderProps } from 'features/posting';

import { getLayout } from '../helpers';

interface IMatchParams {
  content_id: string;
}

interface IPropsEnhanced extends RouteComponentProps<IMatchParams> {}

class Permalink extends Component<IPropsEnhanced> {
  renderContent = (content: Content) => {
    const { match } = this.props;

    const { content_id } = match.params;
    const ContentComponent = getLayout(content);
    const queryParams = {
      query: GetContentDocument,
      variables: { content_id },
    };

    return (
      <QueryParamsProvider value={queryParams}>
        <ContentProvider value={{ content }}>
          <Dimensions>
            {dimensions => (
              <DimensionsProvider value={{ dimensions }}>
                <Post action={PostAction.Edit} key={content.content_id}>
                  {(renderProps: IPostRenderProps) => <ContentComponent {...renderProps} />}
                </Post>
              </DimensionsProvider>
            )}
          </Dimensions>
        </ContentProvider>
      </QueryParamsProvider>
    );
  };

  renderRouteCheck = (props: QueryResult) => {
    const { data } = props;

    if (!data || !data.getContent) {
      return <Route component={NotFound} />;
    }

    return this.renderContent(data.getContent);
  };

  renderMain() {
    const { match } = this.props;
    const { content_id } = match.params;

    return (
      <GetContentComponent variables={{ content_id }} fetchPolicy="network-only">
        {props => <QueryManager {...props}>{() => this.renderRouteCheck(props)}</QueryManager>}
      </GetContentComponent>
    );
  }

  render() {
    return (
      <Layouts.App1Column
        navigation
        desktopSize={6}
        main={<Layouts.AppMain1Column main={this.renderMain()} />}
      />
    );
  }
}

export default withRouter(Permalink);
